class LocalStorageManagerInstance {
  get(key: string) {
    return localStorage.getItem(key)
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value)
  }

  clear() {
    localStorage.clear()
  }

  remove(key: string) {
    localStorage.removeItem(key)
  }
}

const localStorageManager = new LocalStorageManagerInstance()
export default localStorageManager
